/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_EmailInputs */

const en_pricing_compare_email = /** @type {(inputs: Pricing_Compare_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const de_pricing_compare_email = /** @type {(inputs: Pricing_Compare_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const fr_pricing_compare_email = /** @type {(inputs: Pricing_Compare_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const es_pricing_compare_email = /** @type {(inputs: Pricing_Compare_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo`)
};

const it_pricing_compare_email = /** @type {(inputs: Pricing_Compare_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const nl_pricing_compare_email = /** @type {(inputs: Pricing_Compare_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const pl_pricing_compare_email = /** @type {(inputs: Pricing_Compare_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const fi_pricing_compare_email = /** @type {(inputs: Pricing_Compare_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sähköposti`)
};

const da_pricing_compare_email = /** @type {(inputs: Pricing_Compare_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

const sv_pricing_compare_email = /** @type {(inputs: Pricing_Compare_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-post`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Pricing_Compare_EmailInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_email = /** @type {((inputs?: Pricing_Compare_EmailInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_EmailInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_email(inputs)
	if (locale === "fr") return fr_pricing_compare_email(inputs)
	if (locale === "es") return es_pricing_compare_email(inputs)
	if (locale === "it") return it_pricing_compare_email(inputs)
	if (locale === "nl") return nl_pricing_compare_email(inputs)
	if (locale === "pl") return pl_pricing_compare_email(inputs)
	if (locale === "fi") return fi_pricing_compare_email(inputs)
	if (locale === "da") return da_pricing_compare_email(inputs)
	if (locale === "sv") return sv_pricing_compare_email(inputs)
	return en_pricing_compare_email(inputs)
});